import React, { Component } from 'react'
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { Icon } from '@iconify/react';
import { Link } from "react-router-dom";

//Miscellaneous
import { withNamespaces } from "react-i18next";
import StringInput from "../../components/Input/StringInput/StringInput";
import PasswordInput from "../../components/Input/PasswordInput/PasswordInput";
import { default as ReactSelect } from "react-select";
import MobileSidebar from '../../components/Sidebar/MobileSidebar';

export class MobileLoginRegister extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  render() {
    const { t } = this.props;
    const logo = this.imageImport(require.context("../../assets/images/", false, /\.(png|jpe?g|svg|webp)$/));
    const icon = this.imageImport(require.context("../../assets/images/loginregister/", false, /\.(png|jpe?g|svg|webp)$/));
    const flag = this.imageImport(require.context("../../assets/images/flags/", false, /\.(png|jpe?g|svg|webp)$/));
            
    let imageLanguage = '';
    switch (this.props.currentUser.data.language_code) {
      case "zh-CN":
        imageLanguage = "-cn"
        break;
      // case "ms":
      //     imageLanguage = "-ms"
      //     break;
      default:
        imageLanguage = ""
        break;
    }

    return (
      <Auxiliary>
        <section className="logreg-wrap">
          <div style={{ position: "absolute", top: "5.5%", left: "3%"}}>
            <MobileSidebar /> 
          </div>
          <div className="logreg-logo">
            <img src={logo["x33-logo.png"]} alt="logo" />
          </div>
          <div className='pt-4' >
            <img className="left-img" src={icon["img_affliate_bg_1.webp"]} alt="logo" />
          </div>
          {this.props.loginPage === true ? (
            <>

              <div className="logreg-content w-shadow">
                <div className="btn-wrap-mobile">
                  <button className={`btn btn-white ${this.props.loginPage === true && "active"}`} onClick={this.props.toggleLoginPage}>
                    <p>{t("page-header.login")}</p>
                  </button>
                  <button className={`btn btn-white ${this.props.registerPage === true && "active"}`} onClick={this.props.toggleRegisterPage}>
                   <p>{t("page-header.register")}</p>
                  </button>
                </div>
                <div className="logreg-body-wrap">
                  <form
                    className="forms-col needs-validation"
                    noValidate
                    method="post"
                    id="member_login_form"
                    name="member_login_form"
                    onSubmit={this.props.postMemberLogin}
                  >
                    <div className="input-group left has-validation">
                      <span className="input-group-text left-icon">
                        <img src={icon["icon-user.png"]} alt="username icon" />
                      </span>
                      <StringInput
                        className={`form-control ${this.props.errorMsg.loginUsername && "was-validated is-invalid"}`}
                        id="loginUsername"
                        placeholder={t("register.account")}
                        type="text"
                        required
                        requiredMessage={t("validation.required")}
                        autoComplete="off"
                        onChange={this.props.handleLoginUsername}
                        value={this.props.loginUsername}
                        errorMsg={this.props.errorMsg.loginUsername || ""}
                        formError={this.props.formError}
                      />
                    </div>
                    <div className="input-group left has-validation">
                      <span className="input-group-text left-icon">
                        <img src={icon["icon-password.png"]} alt="username icon" />
                      </span>
                      <PasswordInput
                        showPwd={this.props.showLoginPwd}
                        className={`form-control no-border-r ${this.props.errorMsg.loginPassword && "was-validated is-invalid "}`}
                        id="loginPassword"
                        autoComplete="off"
                        placeholder={t("register.enter-password")}
                        onChange={this.props.handleLoginPassword}
                        required
                        requiredMessage={t("validation.required")}
                        value={this.props.loginPassword}
                        errorMsg={this.props.errorMsg.loginPassword || ""}
                        formError={this.props.formError}
                      />
                      <button type="button" className=" right-icon" onClick={this.props.toggleShowLoginPwd}>
                        {this.props.showLoginPwd ? <img src={icon["eye.png"]} alt="show pwd" /> : <img src={icon["close-eye.png"]} alt="hide pwd" />}
                      </button>
                    </div>
                    <div>
                      <button
                        className={`btn btn-outline-blue rounded-pill w-100 text-start ${this.props.verifySuccess === true && "success disabled"}`}
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          this.props.toggleSecurityModal();
                        }}
                      >
                        <span className="left-icon">
                          {!this.props.verifySuccess ? (
                            <img src={icon["icon-shield.png"]} alt="shield icon" />
                          ) : (
                            <img src={icon["shield_2.png"]} alt="username icon" />
                          )}
                        </span>

                        {t("sign-in.verify")}
                      </button>
                      <div className="d-flex justify-content-between small-w mt-2">
                        <div className="checklist text-start">
                        </div>
                        <button className="btn btn-wo-border text-end" type="button" >
                          <Link to={{ pathname: "/forget-password" }}>
                              <small>{t("sign-in.forget-password")}</small>
                          </Link>
                      </button>

                      </div>
                    </div>

                    <button
                      className={`btn btn-gradient-blue rounded-pill ${this.props.loginUsername !== "" && this.props.loginPassword !== "" ? `` : `disabled`
                        }`}
                      type="submit"
                      form="member_login_form"
                    >
                      {t("sign-in.title")}
                    </button>
                  </form>
                </div>
              </div>
            </>
          ) : this.props.registerPage === true ? (
            <div className="logreg-content w-shadow">
              <div className="btn-wrap-mobile">
                <button className={`btn btn-white ${this.props.loginPage === true && "active"}`} onClick={this.props.toggleLoginPage}>
                <p>{t("page-header.login")}</p>
                </button>
                <button className={`btn btn-white ${this.props.registerPage === true && "active"}`} onClick={this.props.toggleRegisterPage}>
                <p>{t("page-header.register")}</p>
                </button>
              </div>
              <div className="logreg-body-wrap">
                <form
                  className="forms-col needs-validation"
                  noValidate
                  method="post"
                  id="member_register_form"
                  name="member_register_form"
                  onSubmit={this.props.postMemberRegister}
                >
                  <div className="input-group left has-validation">
                    <span className="input-group-text left-icon">
                      <img src={icon["icon-user.png"]} alt="username icon" />
                    </span>

                    <StringInput
                      className={`form-control ${this.props.errorMsg.username && "was-validated is-invalid"}`}
                      id="username"
                      placeholder={t("register.account")}
                      type="text"
                      required
                      requiredMessage={t("validation.required")}
                      autoComplete="off"
                      onChange={this.props.handleUsername}
                      onBlur={this.props.handleCheckUsername}
                      value={this.props.username}
                      errorMsg={this.props.errorMsg.username || ""}
                      formError={this.props.formError}
                    />

                    {this.props.check_username === false ? (
                      <div className="invalid-feedback">
                        <Icon icon="akar-icons:circle-alert-fill" />
                        {t("register.username-name-exist")}
                      </div>
                    ) : (
                      <span className="valid-feedback">
                        <Icon icon="akar-icons:circle-check-fill" />
                      </span>
                    )}
                  </div>
                  <div className="input-group left has-validation">
                    <span className="input-group-text left-icon">
                      <img src={icon["icon-password.png"]} alt="username icon" />
                    </span>
                    <PasswordInput
                      showPwd={this.props.showPwd}
                      className={`form-control no-border-r ${this.props.errorMsg.password && "was-validated is-invalid "}`}
                      id="password"
                      autoComplete="off"
                      placeholder={t("register.enter-password")}
                      onChange={this.props.handlePassword}
                      required
                      requiredMessage={t("validation.required")}
                      value={this.props.password}
                      errorMsg={this.props.errorMsg.password || ""}
                      formError={this.props.formError}
                    />
                    <button type="button" className=" right-icon" onClick={this.props.toggleShowPwd}>
                      {this.props.showPwd ? <img src={icon["eye.png"]} alt="show pwd" /> : <img src={icon["close-eye.png"]} alt="hide pwd" />}
                    </button>
                  </div>
                  <div className="input-group left has-validation">
                    <span className="input-group-text left-icon">
                      <img src={icon["icon-password.png"]} alt="username icon" />
                    </span>
                    <PasswordInput
                      showPwdConfirmation={this.props.showPwdConfirmation}
                      className={`form-control no-border-r ${this.props.errorMsg.confirm_password && "was-validated is-invalid "}`}
                      id="confirm_password"
                      autoComplete="off"
                      placeholder={t("register.reenter-password")}
                      required
                      requiredMessage={t("validation.required")}
                      value={this.props.confirm_password}
                      oldPassword={this.props.password}
                      confirmpassword={this.props.confirm_password}
                      onChange={this.props.handleConfirmPassword}
                    />
                    <button type="button" className=" right-icon" onClick={this.props.toggleShowConfirmPwd}>
                      {this.props.showPwdConfirmation ? (
                        <img src={icon["eye.png"]} alt="show pwd" />
                      ) : (
                        <img src={icon["close-eye.png"]} alt="hide pwd" />
                      )}
                    </button>
                  </div>
                  <div className="input-group left has-validation">
                  <ReactSelect
                      classNamePrefix="react-select"
                      defaultValue={this.props.mobileSelectionLabelling.filter(
                        (country) =>
                          country.code === this.props.mobileSelectionShortcode
                      )}
                      options={this.props.contactNoArry}
                      onChange={this.props.handleCountryContactNo}
                      formatOptionLabel={(item) => (
                        <>
                          <img src={flag[`${item.image}`]} alt={item.image} />
                          <p>{item.value}</p>
                          <p>{item.name}</p>
                        </>
                      )}
                    />
                    <StringInput
                      className={`${
                        this.props.errorMsg.contact_number &&
                        "was-validated is-invalid"
                      }`}
                      onChange={this.props.onInputChange}
                      name="contact_no"
                      id="contact_no"
                      placeholder="123456789"
                      value={this.props.contact_no}
                      minLength={this.props.defaultMobileMinLimit}
                      maxLength={this.props.defaultMobileMaxLimit}
                      minLengthMessage={
                        this.props.errorMsg.contact_number
                          ? ""
                          : t("validation.minLength", {
                              0: this.props.defaultMobileMinLimit,
                            })
                      }
                      maxLengthMessage={
                        this.props.errorMsg.contact_number
                          ? ""
                          : t("validation.maxLength", {
                              0: this.props.defaultMobileMaxLimit,
                            })
                      }
                      required
                      requiredMessage={t("validation.required")}
                      errorMsg={this.props.errorMsg.contact_number || ""}
                      formError={this.props.formError}
                    />
                </div>
                  <div className="text-center ">
                    <button
                      className={`btn btn-gradient-blue rounded-pill w-100  ${this.props.formSubmit === false ? `disabled` : ``}`}
                      type="submit"
                      form="member_register_form"
                    >
                      {t("page-header.register")}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          ) : (
            <div className="logreg-content">
              <div className="header-wrap">
                <img className="title-img" src={icon[`login-title-mobile${imageLanguage}.webp`]} alt="title img" />
              </div>
              <div className="btn-wrap">
                <button className={`btn btn-white ${this.props.loginPage === true && "active"}`} onClick={this.props.toggleLoginPage}>
                <p>{t("page-header.login")}</p>
                </button>
                <button className={`btn btn-white ${this.props.registerPage === true && "active"}`} onClick={this.props.toggleRegisterPage}>
                <p>{t("page-header.register")}</p>
                </button>
              </div>
            </div>
          )}
        </section>
      </Auxiliary>
    )
  }
}

export default (withNamespaces("translation")(MobileLoginRegister))